import { ArrowRight } from 'lucide-react'

import { Button, Field } from '../../components/ui'
import type { ContributorDetails } from '../../types/submission'

interface DetailsStepProps {
  details: ContributorDetails
  onChange: (details: ContributorDetails) => void
  onContinue: () => void
  saving: boolean
}

export function DetailsStep({ details, onChange, onContinue, saving }: DetailsStepProps) {
  const update = (field: keyof Omit<ContributorDetails, 'socialLinks'>, value: string) => {
    onChange({ ...details, [field]: value })
  }

  const updateSocial = (field: keyof ContributorDetails['socialLinks'], value: string) => {
    onChange({ ...details, socialLinks: { ...details.socialLinks, [field]: value } })
  }

  return (
    <section className="step-panel" aria-labelledby="details-heading">
      <div className="step-panel__intro">
        <h2 id="details-heading">Your details</h2>
        <p>Tell the editors how to reach you and exactly how your work should be credited.</p>
      </div>

      <div className="form-grid form-grid--two">
        <Field
          label="Your name"
          name="contactName"
          autoComplete="name"
          value={details.contactName}
          onChange={(event) => update('contactName', event.target.value)}
          required
        />
        <Field
          label="Email address"
          name="contactEmail"
          type="email"
          autoComplete="email"
          value={details.contactEmail}
          onChange={(event) => update('contactEmail', event.target.value)}
          required
        />
      </div>

      <Field
        label="Credit my images as"
        name="creditName"
        value={details.creditName}
        onChange={(event) => update('creditName', event.target.value)}
        hint="This is the public name High Times will use if your image is selected."
        required
      />

      <div className="step-panel__section-heading">
        <h3>Social links</h3>
        <span>Optional</span>
      </div>
      <div className="form-grid form-grid--two">
        <Field
          label="Instagram"
          name="instagram"
          placeholder="@yourhandle"
          value={details.socialLinks.instagram}
          onChange={(event) => updateSocial('instagram', event.target.value)}
        />
        <Field
          label="Website"
          name="website"
          placeholder="https://"
          value={details.socialLinks.website}
          onChange={(event) => updateSocial('website', event.target.value)}
        />
        <Field
          label="Facebook"
          name="facebook"
          placeholder="Profile or page URL"
          value={details.socialLinks.facebook}
          onChange={(event) => updateSocial('facebook', event.target.value)}
        />
        <Field
          label="X"
          name="x"
          placeholder="@yourhandle"
          value={details.socialLinks.x}
          onChange={(event) => updateSocial('x', event.target.value)}
        />
      </div>

      <footer className="step-actions step-actions--end">
        <Button onClick={onContinue} disabled={saving} icon={<ArrowRight size={20} />}>
          {saving ? 'Saving…' : 'Add strains & photos'}
        </Button>
      </footer>
    </section>
  )
}
